import React, {useEffect, useState} from 'react';
import {
    Alert,
    Badge,
    Card,
    CardBody,
    Col,
    Container, Input, Nav, NavItem, NavLink,
    Row, Spinner, TabContent, TabPane
} from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';

import {ClassRoomAPI, ClassroomIndividualAPI, ClassRoomInsideAPI, LeadAPI, PaymentAPI} from "api";
import {Link, useParams, useHistory} from "react-router-dom";
import {
    Loading,
    RevertClassroom,
    Utils
} from "custom";

import {_, Grid} from "gridjs-react";
import LessonInside from "./ClassroomInside/LessonInside";
import BoardInside from "./ClassroomInside/BoardInside";
import CompleteIndividualClassroomModal from "./ClassroomInside/CompleteIndividualClassroomModal";
import AttendancesInside from "./ClassroomInside/AttendancesInside";

const moment = require("moment");

const ClassRoomIndividualMainInside = () => {
    document.title = "Dettaglio Classe | CLTV Cloud";

    const history = useHistory()

    const [loading, setLoading] = useState(true);
    const [classroom, setClassroom] = useState(null);
    const [lessons, setLessons] = useState([]);
    const [posts, setPosts] = useState([]);

    const [activeTab, setActiveTab] = useState("1");

    const [error, setError] = useState(false);

    const [editClassEnd, setEditClassEnd] = useState(false);

    const [isCompleteModalOpen, setIsCompleteModalOpen] = useState(false);

    const isAdmin = (Utils.getUserData().role === "ADMIN");
    const isTeacher = (Utils.getUserData().role === "TEACHER");
    const isClient = (Utils.getUserData().role === "CLIENT");

    const {id} = useParams();

    const toggleCompleteModal = () => setIsCompleteModalOpen((prev) => !prev);

    useEffect(() => {
        getDetailClassroom();

        // Default tab è "1" (Bacheca): se il CLIENT entra nella classroom, segno letto
        if (Utils.getUserData().role === "CLIENT") {
            ClassroomIndividualAPI.markBoardSeenIndividual(id).catch((e) => {
                console.error('markBoardSeenIndividual failed:', e);
            });
        }
    }, []);

    const changeTab = (tab) => {
        setActiveTab(tab)

        // Quando il CLIENT apre la tab Bacheca, segno i messaggi come letti
        if (tab === "1" && Utils.getUserData().role === "CLIENT") {
            ClassroomIndividualAPI.markBoardSeenIndividual(id).catch((e) => {
                console.error('markBoardSeenIndividual failed:', e);
            });
        }
    }



    const getDetailClassroom = () => {
        ClassroomIndividualAPI.detail(id).then(async (res) => {
            setClassroom(() => res)
            setLoading(false)
            setError(false);

        }).catch((err) => {
            setError(true);
            console.error(err);
        })
    }

    const printStatus = () => {
        switch(classroom.status) {
            case "WAITING":
                return <div className="badge rounded-pill bg-warning fs-12">In Programmazione</div>;
            case "ACTIVE":
                return <div className="badge rounded-pill bg-primary fs-12">In Corso</div>;
            case "COMPLETED":
                return <div className="badge rounded-pill bg-success fs-12">Completata</div>;
            default:
                return null;
        }
    }

    const printResult = () => {
        if (!classroom.result_enrollment) return null;
        switch(classroom.result_enrollment) {
            case "PASSED":
                return <span className="badge rounded-pill bg-success fs-12"><i className="mdi mdi-check-circle"></i> Passato</span>;
            case "NOT_PASSED":
                return <span className="badge rounded-pill bg-danger fs-12"><i className="mdi mdi-close-circle"></i> Non passato</span>;
            case "ABANDONED":
                return <span className="badge rounded-pill bg-warning fs-12"><i className="mdi mdi-account-remove"></i> Abbandono</span>;
            default:
                return null;
        }
    }

    const handleCompleteSubmit = (payload) => {
        setLoading(true);

        ClassroomIndividualAPI.complete(payload).then((res) => {
            setIsCompleteModalOpen(false);

            const parts = [
                `Esito: <b>${res.result === "PASSED" ? "Passato" : "Non passato"}</b>`
            ];

            if (res.result === "PASSED" && res.isFinalModule) {
                parts.push(`Attestati generati: <b>${res.certificatesGenerated}</b>`);
                parts.push(`Email inviate: <b>${res.emailsSent}</b>`);
                if (res.emailsFailed > 0)
                    parts.push(`Email fallite: <b class="text-danger">${res.emailsFailed}</b>`);
            } else if (res.result === "PASSED") {
                parts.push(`<i>Modulo intermedio: nessun attestato generato.</i>`);
            }

            global.SweetAlert.fire({
                icon: 'success',
                title: 'Classe completata!',
                html: `<div style="text-align:left">${parts.map(p => `<p>${p}</p>`).join('')}</div>`,
                customClass: { confirmButton: 'btn btn-success' }
            });

            getDetailClassroom();
        }).catch((err) => {
            setLoading(false);
            console.error(err);

            let message = 'Non è stato possibile completare la classe. Riprova più tardi.';
            if (err?.status === "PARTECIPANT_ABANDONED") message = "Il corsista ha già abbandonato questa classe.";
            if (err?.status === "INVALID_FORM") message = "Alcuni dati non sono validi: " + (err.message || "");
            if (err?.status === "CLASSROOM_NOT_FOUND") message = "Classe non trovata o non in stato ACTIVE.";

            global.SweetAlert.fire({
                icon: 'error',
                title: 'Si è verificato un errore',
                text: message,
                customClass: { confirmButton: 'btn btn-danger' }
            });
        });
    };

    const handleAbandon = () => {
        global.SweetAlert.fire({
            title: "Segnare l'abbandono?",
            text: 'Stai segnando come "abbandono" il corsista ' + classroom.client_name + '. La classe verrà chiusa senza attestato. Continuare?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, segna abbandono',
            cancelButtonText: 'Annulla',
            customClass: { confirmButton: 'btn btn-warning', cancelButton: 'btn btn-outline-warning ms-1' },
            buttonsStyling: false
        }).then((r) => {
            if (!r.value) return;

            ClassroomIndividualAPI.abandon(classroom.id).then(() => {
                global.SweetAlert.fire({
                    icon: 'success',
                    title: 'Abbandono registrato',
                    customClass: { confirmButton: 'btn btn-success' }
                });
                getDetailClassroom();
            }).catch((e) => {
                console.error(e);
                let msg = "Non è stato possibile registrare l'abbandono.";
                if (e?.status === "ENROLLMENT_ALREADY_EXISTS") msg = "Il corsista ha già un esito registrato per questa classe.";
                global.SweetAlert.fire({
                    icon: 'error',
                    title: 'Errore',
                    text: msg,
                    customClass: { confirmButton: 'btn btn-danger' }
                });
            });
        });
    };

    // const setEndClassroom = (dateEnd) => {
    //     setLoading(() => true)
    //     ClassroomIndividualAPI.edit().then(() => {
    //         getDetailClassroom();
    //         setEditClassEnd(false)
    //         global.SweetAlert.fire({
    //             icon: 'success',
    //             title: 'Data fine classe modificata!',
    //             customClass: {
    //                 confirmButton: 'btn btn-success'
    //             }
    //         });
    //     }).catch((e) => {
    //         setLoading(() => false)
    //
    //         let message = 'Non è stato possibile modificare la data di fine classe. Riprova più tardi.';
    //
    //         if (e.status === "CLASSROOM_CONFLICT")
    //             message = "La data di fine classi va in conflitto con altre classi già esistenti.";
    //
    //         global.SweetAlert.fire({
    //             icon: 'error',
    //             title: 'Si è verificato un errore :(',
    //             text: message,
    //             customClass: {
    //                 confirmButton: 'btn btn-success'
    //             }
    //         });
    //     })
    // }


    if (error) {
        return <React.Fragment>
            <div className="page-content">
                <Alert color="danger" >Si è verificato un errore durante il recupero del dettaglio classe.</Alert>
            </div>
        </React.Fragment>
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {(loading) ? <Loading/> : <React.Fragment>
                        <Row>
                            <Col lg={12}>
                                <Card className="mt-n4 mx-n4">
                                    <div className="bg-soft-warning">
                                        <CardBody className="pb-0 px-4">
                                            <Row className="mb-3">
                                                <div className="col-md">
                                                    <Row className="align-items-center g-3">
                                                        <div className="col-md-auto">
                                                            <div className="avatar-md">
                                                                <div className="avatar-title bg-white rounded-circle">
                                                                    <img src={require("../../assets/images/avatar-cltv.png")} alt="" className="avatar-md" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md">
                                                            <div>
                                                                <h4 className="fw-bold">{classroom.client_name}{classroom.level ? " - " + classroom.level.name : ""}</h4>
                                                                <div className="hstack gap-3 flex-wrap">
                                                                    <div><i className="ri-user-2-fill align-bottom me-1"></i> Docente: <b>{classroom.teacher}</b></div>
                                                                    {(classroom.date_start && (!isClient || classroom.status === "ACTIVE" || classroom.status === "COMPLETED")) ? <React.Fragment>
                                                                        <div className="vr"></div>
                                                                        <div>Data Inizio: <span className="fw-medium">{moment(classroom.date_start, "YYYY-MM-DD").format("DD MMM YYYY")}</span></div>
                                                                    </React.Fragment> : null}
                                                                    {(classroom.date_end && (!isClient || classroom.status === "ACTIVE" || classroom.status === "COMPLETED")) ? <React.Fragment>
                                                                        <div className="vr"></div>
                                                                        <div>Data Fine: <span className="fw-medium">{moment(classroom.date_end, "YYYY-MM-DD").format("DD MMM YYYY")}</span></div>
                                                                    </React.Fragment> : null}
                                                                    <div className="vr"></div>
                                                                    {printStatus()}
                                                                    {printResult()}

                                                                    {(classroom.status === "ACTIVE" && !classroom.result_enrollment && (isTeacher || isAdmin)) ? <button
                                                                        type="button"
                                                                        className="btn btn-success btn-sm"
                                                                        onClick={toggleCompleteModal}
                                                                    >
                                                                        <i className="ri-check-fill align-bottom me-1"></i>
                                                                        COMPLETA CLASSE
                                                                    </button> : null}

                                                                    {(classroom.status === "ACTIVE" && !classroom.result_enrollment && (isTeacher || isAdmin)) ? <button
                                                                        type="button"
                                                                        className="btn btn-outline-warning btn-sm"
                                                                        onClick={handleAbandon}
                                                                    >
                                                                        <i className="mdi mdi-account-remove align-bottom me-1"></i>
                                                                        SEGNA ABBANDONO
                                                                    </button> : null}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Row>
                                                </div>
                                            </Row>

                                            <Nav className="nav-tabs-custom border-bottom-0" role="tablist">
                                                <NavItem>
                                                    <NavLink
                                                        className={(activeTab === "1") ? "active fw-semibold" : ""}
                                                        onClick={() => { changeTab('1'); }}
                                                        href="javascript:void(0)">
                                                        Bacheca
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        className={(activeTab === "2") ? "active fw-semibold" : ""}
                                                        onClick={() => { changeTab('2'); }}
                                                        href="javascript:void(0)">
                                                        Lezioni
                                                    </NavLink>
                                                </NavItem>
                                                {/* Non al corsista: la rotta ammette ADMIN, TEACHER e CONSULENT. */}
                                                {(!isClient) ? <NavItem>
                                                    <NavLink
                                                        className={(activeTab === "3") ? "active fw-semibold" : ""}
                                                        onClick={() => { changeTab('3'); }}
                                                        href="javascript:void(0)">
                                                        Presenze
                                                    </NavLink>
                                                </NavItem> : null}
                                            </Nav>
                                        </CardBody>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <TabContent activeTab={activeTab} className="text-muted">
                                    <TabPane tabId="1">
                                        <BoardInside posts={classroom.posts} classroomId={classroom.id} onResolve={getDetailClassroom}/>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <LessonInside lessons={classroom.lessons || []} classroomId={classroom.id} classroom={classroom} onResolve={getDetailClassroom}/>
                                    </TabPane>
                                    {/* Montato solo quando la scheda e' aperta: cosi' la chiamata parte a quel
                                        punto e i dati sono freschi ogni volta che ci si torna. */}
                                    {(!isClient && activeTab === "3") ? <TabPane tabId="3">
                                        <AttendancesInside classroomId={classroom.id}/>
                                    </TabPane> : null}
                                </TabContent>
                            </Col>
                        </Row>

                        <CompleteIndividualClassroomModal
                            isOpen={isCompleteModalOpen}
                            toggle={toggleCompleteModal}
                            classroom={classroom}
                            onSubmit={handleCompleteSubmit}
                        />
                    </React.Fragment>}
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ClassRoomIndividualMainInside;
